import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { toPointer } from '../../core/issues.js';

/**
 * The host avatar is identified by a "host" slug. Player and contestant may use
 * any cluster character from content-assets.json["gameshow"].characters, but the
 * narrator (host) must reference a slug containing "host" (e.g.
 * character-gameshow-host-3) so the host reads as a host across clusters.
 */
const HOST_MARKER = 'host';

export const gameshowNarratorSlug: Rule<Gameshow> = {
  code: 'gameshow.narrator.slug-host',
  check(input): ValidationIssue[] {
    const slug = (input as { narratorContentAssetSlug?: unknown }).narratorContentAssetSlug;
    // Absent/empty slugs are out of scope here (the shared slug-presence /
    // slug-known rules own that case).
    if (typeof slug !== 'string' || slug.length === 0) {
      return [];
    }
    if (slug.toLowerCase().includes(HOST_MARKER)) {
      return [];
    }

    const path: (string | number)[] = ['narratorContentAssetSlug'];
    return [
      {
        code: 'gameshow.narrator.slug-host',
        severity: 'error',
        message: `Gameshow host avatar must use a '${HOST_MARKER}' slug; narratorContentAssetSlug '${slug}' does not contain '${HOST_MARKER}'.`,
        path,
        pointer: toPointer(path),
        currentValue: slug,
        constraint: { kind: 'custom', detail: `narratorContentAssetSlug must contain '${HOST_MARKER}'` },
      },
    ];
  },
};
